import { mapMutations, mapActions } from 'vuex'
export default {
  methods: {
    ...mapMutations('opedModal', ['hideModal']),
    ...mapActions('opedModal', [
      'showModalMain',
      'showModalPlan',
			'showModalPayment',
			'showModalRegistConfirm',
			'showModalRegistThanks',
      'showModalContact',
      'showModalContactThanks',
      'showModalSearch',
      'showModalLogin',
      'showModalLostPassword',
      'showModalLostPasswordThanks',
			'showModalMainMenu',
			'showModalMypageTop',
			'showModalEditThanks',
			'showModalEditPlanConfirm',
			'showModalEditPlanThanks',
    ]),
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/vue/component/mixins/ModalMixin.js